import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard/dashboard.component';
import { AnalyticsComponent } from './components/pages/dashboard/analytics/analytics.component';
import { EcommerceComponent } from './components/pages/dashboard/ecommerce/ecommerce.component';
import { AppChatComponent } from './components/pages/app-chat/app-chat.component';
import { AppTodoComponent } from './components/pages/app-todo/app-todo.component';
import { AppCalendarComponent } from './components/pages/app-calendar/app-calendar.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { TimelineComponent } from './components/pages/timeline/timeline.component';
import { GalleryComponent } from './components/pages/gallery/gallery.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { InvoiceComponent } from './components/pages/invoice/invoice.component';
import { BlankPageComponent } from './components/pages/blank-page/blank-page.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { GridComponent } from './components/pages/grid/grid.component';
import { ColorsComponent } from './components/pages/colors/colors.component';
import { BoxiconsComponent } from './components/pages/icons/boxicons/boxicons.component';
import { FeathericonsComponent } from './components/pages/icons/feathericons/feathericons.component';
import { IconsComponent } from './components/pages/icons/icons/icons.component';
import { CardComponent } from './components/pages/card/card/card.component';
import { BasicCardComponent } from './components/pages/card/basic-card/basic-card.component';
import { ColorsCardComponent } from './components/pages/card/colors-card/colors-card.component';
import { StatisticsCardComponent } from './components/pages/card/statistics-card/statistics-card.component';
import { FormComponent } from './components/pages/forms/form/form.component';
import { FormLayoutComponent } from './components/pages/forms/form-layout/form-layout.component';
import { FormInputGroupComponent } from './components/pages/forms/form-input-group/form-input-group.component';
import { TableComponent } from './components/pages/table/table/table.component';
import { TableLightComponent } from './components/pages/table/table-light/table-light.component';
import { TableDarkComponent } from './components/pages/table/table-dark/table-dark.component';
import { InboxComponent } from './components/pages/app-email/inbox/inbox.component';
import { ReadComponent } from './components/pages/app-email/read/read.component';
import { ComposeComponent } from './components/pages/app-email/compose/compose.component';
import { UiComponentsComponent } from './components/pages/ui-components/ui-components/ui-components.component';
import { AlertsComponent } from './components/pages/ui-components/alerts/alerts.component';
import { AppEmailComponent } from './components/pages/app-email/app-email/app-email.component';
import { BadgesComponent } from './components/pages/ui-components/badges/badges.component';
import { BordersComponent } from './components/pages/ui-components/borders/borders.component';
import { BreadcrumbComponent } from './components/pages/ui-components/breadcrumb/breadcrumb.component';
import { ButtonsComponent } from './components/pages/ui-components/buttons/buttons.component';
import { ButtonsGroupComponent } from './components/pages/ui-components/buttons-group/buttons-group.component';
import { SliderComponent } from './components/pages/ui-components/slider/slider.component';
import { CollapseComponent } from './components/pages/ui-components/collapse/collapse.component';
import { DisplayComponent } from './components/pages/ui-components/display/display.component';
import { DropdownComponent } from './components/pages/ui-components/dropdown/dropdown.component';
import { EmbedComponent } from './components/pages/ui-components/embed/embed.component';
import { FiguresComponent } from './components/pages/ui-components/figures/figures.component';
import { ImagesComponent } from './components/pages/ui-components/images/images.component';
import { JumbotronComponent } from './components/pages/ui-components/jumbotron/jumbotron.component';
import { ListGroupComponent } from './components/pages/ui-components/list-group/list-group.component';
import { MediaObjectComponent } from './components/pages/ui-components/media-object/media-object.component';
import { ModalComponent } from './components/pages/ui-components/modal/modal.component';
import { NavsComponent } from './components/pages/ui-components/navs/navs.component';
import { NavbarComponent } from './components/pages/ui-components/navbar/navbar.component';
import { SpinnerComponent } from './components/pages/ui-components/spinner/spinner.component';
import { TextComponent } from './components/pages/ui-components/text/text.component';
import { VerticalAlignmentComponent } from './components/pages/ui-components/vertical-alignment/vertical-alignment.component';
import { TypographyComponent } from './components/pages/ui-components/typography/typography.component';
import { TooltipsComponent } from './components/pages/ui-components/tooltips/tooltips.component';
import { PopoversComponent } from './components/pages/ui-components/popovers/popovers.component';
import { ProgressComponent } from './components/pages/ui-components/progress/progress.component';
import { AuthenticationComponent } from './components/pages/authentication/authentication/authentication.component';
import { LoginComponent } from './components/pages/authentication/login/login.component';
import { LoginWithImageComponent } from './components/pages/authentication/login-with-image/login-with-image.component';
import { RegisterComponent } from './components/pages/authentication/register/register.component';
import { RegisterWithImageComponent } from './components/pages/authentication/register-with-image/register-with-image.component';
import { ForgotPasswordComponent } from './components/pages/authentication/forgot-password/forgot-password.component';
import { ForgotPasswordWithImageComponent } from './components/pages/authentication/forgot-password-with-image/forgot-password-with-image.component';
import { ResetPasswordComponent } from './components/pages/authentication/reset-password/reset-password.component';
import { ResetPasswordWithImageComponent } from './components/pages/authentication/reset-password-with-image/reset-password-with-image.component';
import { SessionLockScreenComponent } from './components/pages/authentication/session-lock-screen/session-lock-screen.component';
import { SessionLockScreenWithImageComponent } from './components/pages/authentication/session-lock-screen-with-image/session-lock-screen-with-image.component';
import { NotAuthorizedComponent } from './components/pages/miscellaneous/not-authorized/not-authorized.component';
import { NotAuthorizedWithImageComponent } from './components/pages/miscellaneous/not-authorized-with-image/not-authorized-with-image.component';
import { MaintenanceComponent } from './components/pages/miscellaneous/maintenance/maintenance.component';
import { MaintenanceWithImageComponent } from './components/pages/miscellaneous/maintenance-with-image/maintenance-with-image.component';
import { ComingSoonComponent } from './components/pages/miscellaneous/coming-soon/coming-soon.component';
import { ComingSoonWithImageComponent } from './components/pages/miscellaneous/coming-soon-with-image/coming-soon-with-image.component';
import { MiscellaneousComponent } from './components/pages/miscellaneous/miscellaneous/miscellaneous.component';
import { ErrorComponent } from './components/pages/error/error/error.component';
import { Errorv1Component } from './components/pages/error/errorv1/errorv1.component';
import { Errorv2Component } from './components/pages/error/errorv2/errorv2.component';
import { Errorv3Component } from './components/pages/error/errorv3/errorv3.component';
import { Errorv4Component } from './components/pages/error/errorv4/errorv4.component';
import { MapsComponent } from './components/pages/maps/maps.component';
import { WebAnalyticsComponent } from './components/charts/web-analytics/web-analytics.component';
import { EmailSendComponent } from './components/charts/email-send/email-send.component';
import { ActivityTimelineComponent } from './components/charts/activity-timeline/activity-timeline.component';
import { TrafficSourceComponent } from './components/charts/traffic-source/traffic-source.component';
import { RevenueSummaryComponent } from './components/charts/revenue-summary/revenue-summary.component';
import { ClientRecollectionComponent } from './components/charts/client-recollection/client-recollection.component';
import { RevenueGrowthComponent } from './components/charts/revenue-growth/revenue-growth.component';
import { ApexChartsComponent } from './components/pages/apex-charts/apex-charts.component';
import { BasicLineChartComponent } from './components/charts/basic-line-chart/basic-line-chart.component';
import { LineWithDataLabelsComponent } from './components/charts/line-with-data-labels/line-with-data-labels.component';
import { AnnotationsLineComponent } from './components/charts/annotations-line/annotations-line.component';
import { GradientLineComponent } from './components/charts/gradient-line/gradient-line.component';
import { DashedLineComponent } from './components/charts/dashed-line/dashed-line.component';
import { ZoomableLineTimeseriesComponent } from './components/charts/zoomable-line-timeseries/zoomable-line-timeseries.component';
import { BasicAreaChartComponent } from './components/charts/basic-area-chart/basic-area-chart.component';
import { SplineAreaComponent } from './components/charts/spline-area/spline-area.component';
import { NegativeAreaComponent } from './components/charts/negative-area/negative-area.component';
import { StackedAreaComponent } from './components/charts/stacked-area/stacked-area.component';
import { AreaDatetimeXAxisComponent } from './components/charts/area-datetime-x-axis/area-datetime-x-axis.component';
import { BasicColumnChartComponent } from './components/charts/basic-column-chart/basic-column-chart.component';
import { ColumnWithDataLabelsComponent } from './components/charts/column-with-data-labels/column-with-data-labels.component';
import { StackedColumnsComponent } from './components/charts/stacked-columns/stacked-columns.component';
import { StackedColumnsHundredPercentComponent } from './components/charts/stacked-columns-hundred-percent/stacked-columns-hundred-percent.component';
import { ColumnWithNegativeValuesComponent } from './components/charts/column-with-negative-values/column-with-negative-values.component';
import { DynamicLoadedColumnComponent } from './components/charts/dynamic-loaded-column/dynamic-loaded-column.component';
import { BasicBarChartComponent } from './components/charts/basic-bar-chart/basic-bar-chart.component';
import { GroupedBarComponent } from './components/charts/grouped-bar/grouped-bar.component';
import { StackedBarComponent } from './components/charts/stacked-bar/stacked-bar.component';
import { StackedBarHundredPercentComponent } from './components/charts/stacked-bar-hundred-percent/stacked-bar-hundred-percent.component';
import { BarWithNegativeValuesComponent } from './components/charts/bar-with-negative-values/bar-with-negative-values.component';
import { CustomDatalabelsBarComponent } from './components/charts/custom-datalabels-bar/custom-datalabels-bar.component';
import { MixedLineColumnComponent } from './components/charts/mixed-line-column/mixed-line-column.component';
import { MixedMultipleYAxisComponent } from './components/charts/mixed-multiple-y-axis/mixed-multiple-y-axis.component';
import { MixedLineAndAreaComponent } from './components/charts/mixed-line-and-area/mixed-line-and-area.component';
import { MixedLineColumnAreaComponent } from './components/charts/mixed-line-column-area/mixed-line-column-area.component';
import { SimplePieChartComponent } from './components/charts/simple-pie-chart/simple-pie-chart.component';
import { SimpleDonutChartComponent } from './components/charts/simple-donut-chart/simple-donut-chart.component';
import { MonochromePieComponent } from './components/charts/monochrome-pie/monochrome-pie.component';
import { GradientDonutComponent } from './components/charts/gradient-donut/gradient-donut.component';
import { DonutWithPatternComponent } from './components/charts/donut-with-pattern/donut-with-pattern.component';
import { PieWithImageComponent } from './components/charts/pie-with-image/pie-with-image.component';
import { BasicRadialbarChartComponent } from './components/charts/basic-radialbar-chart/basic-radialbar-chart.component';
import { MultipleRadialbarComponent } from './components/charts/multiple-radialbar/multiple-radialbar.component';
import { RadialbarCustomAngleCircleComponent } from './components/charts/radialbar-custom-angle-circle/radialbar-custom-angle-circle.component';
import { RadialbarGradientCircleComponent } from './components/charts/radialbar-gradient-circle/radialbar-gradient-circle.component';
import { RadialbarStrokedCircularGaugeComponent } from './components/charts/radialbar-stroked-circular-gauge/radialbar-stroked-circular-gauge.component';
import { RadialbarSemiCircularGaugeComponent } from './components/charts/radialbar-semi-circular-gauge/radialbar-semi-circular-gauge.component';
import { RadialbarsWithImageComponent } from './components/charts/radialbars-with-image/radialbars-with-image.component';
import { BasicRadarChartComponent } from './components/charts/basic-radar-chart/basic-radar-chart.component';
import { RadarMultipleSeriesComponent } from './components/charts/radar-multiple-series/radar-multiple-series.component';
import { RadarWithPolygonFillComponent } from './components/charts/radar-with-polygon-fill/radar-with-polygon-fill.component';
import { ChartjsComponent } from './components/pages/chartjs/chartjs.component';
import { BasicBarChartv2Component } from './components/charts/basic-bar-chartv2/basic-bar-chartv2.component';
import { BasicLineChartv2Component } from './components/charts/basic-line-chartv2/basic-line-chartv2.component';
import { BasicPieChartComponent } from './components/charts/basic-pie-chart/basic-pie-chart.component';
import { BasicRadarChartv2Component } from './components/charts/basic-radar-chartv2/basic-radar-chartv2.component';
import { BasicHorizontalBarComponent } from './components/charts/basic-horizontal-bar/basic-horizontal-bar.component';
import { BarWithLineComponent } from './components/charts/bar-with-line/bar-with-line.component';
import { ResendConfirmationComponent } from './components/pages/authentication/resend-confirmation/resend-confirmation.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { from } from 'rxjs';
import { InvoiceSaleComponent } from './components/pages/inventory/sales/invoice-sale/invoice-sale.component';
import { RecurrenceComponent } from './components/pages/dashboard/recurrence/recurrence.component';
import { AuthenticationInterceptor } from './components/pages/authentication/authentication/authentication.interceptor';
import { SelectCompanyComponent } from './components/pages/companies/select-company/select-company.component';
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { IdleModalComponent } from './components/modals/idle-modal/idle-modal.component';
import { InputAutocompleteComponent } from './components/elements/input-autocomplete/input-autocomplete.component';
import { SuccessModalComponent } from './components/modals/success-modal/success-modal.component';
import { CashClosureComponent } from './components/pages/dashboard/cash-closure/cash-closure.component';
import { SalesComponent } from './components/pages/inventory/sales/sales/sales.component';
import { EditInvoiceComponent } from './components/pages/configuration/edit-invoice/edit-invoice.component';
import { AccountsReceivableComponent } from './components/pages/dashboard/accounts-receivable/accounts-receivable.component';
import { ConfigurationComponent } from './components/pages/configuration/configuration.component';
import { RolesAndPermissionsComponent } from './components/pages/configuration/roles-and-permissions/roles-and-permissions.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PriceListComponent } from './components/pages/inventory/sales/price-list/price-list.component';
import { PriceListModalComponent } from './components/modals/price-list-modal/price-list-modal.component';
import { UserRoleComponent } from './components/pages/configuration/user-role/user-role.component';
import { CheckPermissionDirective } from './security/check-permission.directive';
import { HumanResourcesComponent } from './components/pages/human-resources/human-resources.component';
import { OrganizationComponent } from './components/pages/human-resources/organization/organization.component';
import { D3OrgChartComponent } from './components/elements/d3-org-chart/d3-org-chart.component';
import { InventoryComponent } from './components/pages/configuration/inventory/inventory.component';
import { CategoriesComponent } from './components/pages/configuration/inventory/categories/categories.component';
import { ReportsComponent } from './components/pages/reports/reports.component';
import { InventoryReportComponent } from './components/pages/reports/inventory-report/inventory-report.component';
import { BankReportComponent } from './components/pages/reports/bank-report/bank-report.component';
import { PaginationComponent } from './components/elements/pagination/pagination.component';
import { AccountReceivableReportComponent } from './components/pages/reports/account-receivable-report/account-receivable-report.component';
import { AccountPayableReportComponent } from './components/pages/reports/account-payable-report/account-payable-report.component';
import { SpendingReportComponent } from './components/pages/reports/spending-report/spending-report.component';
import { CashBankComponent } from './components/pages/dashboard/transferCashBank/cash-bank.component';
import { AccountingReportComponent } from './components/pages/reports/accounting-report/accounting-report.component';
import { WarehousesComponent } from './components/pages/configuration/inventory/warehouses/warehouses.component';
import { BankConfigurationComponent } from './components/pages/configuration/bank-configuration/bank-configuration.component';
import { AccountsConfigurationComponent } from './components/pages/configuration/bank-configuration/accounts-configuration/accounts-configuration.component';
import { ModalCreateWarehouseComponent } from './components/modals/modal-create-warehouse/modal-create-warehouse.component';
import { ModalEditWarehouseComponent } from './components/modals/modal-edit-warehouse/modal-edit-warehouse.component';
import { CashiersComponent } from './components/pages/configuration/bank-configuration/cashiers/cashiers.component';
import { ModalCashierComponent } from './components/modals/modal-cashier/modal-cashier.component';
import { VendorsComponent } from './components/pages/configuration/inventory/vendors/vendors.component';
import { BudgetComponent } from './components/pages/inventory/sales/budget/budget.component';
import { ModalVendorComponent } from './components/modals/modal-vendor/modal-vendor.component';
import { HistorySalesComponent } from './components/pages/historical/history-sales/history-sales.component';
import { ModalInvoiceSaleComponent } from './components/modals/modal-invoice-sale/modal-invoice-sale.component';
import { HistoryCotiComponent } from './components/pages/historical/history-coti/history-coti.component';
import { AccountingChartResultComponent } from './components/charts/accounting-chart-result/accounting-chart-result.component';
import { AccountingChartBalanceComponent } from './components/charts/accounting-chart-balance/accounting-chart-balance.component';
import { AccountingChartExpensesComponent } from './components/charts/accounting-chart-expenses/accounting-chart-expenses.component';
import { AccountingChartProfitsVsCostsComponent } from './components/charts/accounting-chart-profits-vs-costs/accounting-chart-profits-vs-costs.component';
import { AnalyticsCustomComponent } from './components/pages/dashboard/analytics-custom/analytics-custom.component';
import { HistoricalComponent } from './components/pages/historical/historical/historical.component';
import { HistoryPurchasesComponent } from './components/pages/historical/history-purchases/history-purchases.component';
import { PurchasesComponent } from './components/pages/inventory/purchases/purchases/purchases.component';
import { InvoicePurchaseComponent } from './components/pages/inventory/purchases/invoice-purchase/invoice-purchase.component';
import { ProductsComponent } from './components/pages/configuration/inventory/products/products.component';
import { ModalCreateProductComponent } from './components/modals/modal-create-product/modal-create-product.component';
import { OrdersComponent } from './components/pages/inventory/orders/orders/orders.component';
import { OrderListComponent } from './components/pages/inventory/orders/order-list/order-list.component';
import { ModalCreateOrderComponent } from './components/modals/modal-create-order/modal-create-order.component';
import { ModalCreatePurchaseOrderComponent } from './components/modals/modal-create-purchase-order/modal-create-purchase-order.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ProfitMarginComponent } from './components/pages/inventory/sales/profit-margin/profit-margin.component';
import { ModalPolishOffOrderComponent } from './components/modals/modal-polish-off-order/modal-polish-off-order.component';
import { JobsComponent } from './components/pages/human-resources/jobs/jobs.component';
import { ModalLocationComponent } from './components/modals/modal-location/modal-location.component';
import { TransferProductsComponent } from './components/pages/inventory/sales/transfer-products/transfer-products.component';
import { ModalAdminAreaComponent } from './components/modals/modal-admin-area/modal-admin-area.component';
import { ModalQuestionComponent } from './components/modals/modal-question/modal-question.component';
import { ModalAdminDepartmentComponent } from './components/modals/modal-admin-department/modal-admin-department.component';
import { ModalAdminPositionComponent } from './components/modals/modal-admin-position/modal-admin-position.component';
import { HiringComponent } from './components/pages/human-resources/hiring/hiring.component';
import { ModalHiringComponent } from './components/modals/modal-hiring/modal-hiring.component';
import { ModalSalaryProfileComponent } from './components/modals/modal-salary-profile/modal-salary-profile.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalHiringDocumentsComponent } from './components/modals/modal-hiring-documents/modal-hiring-documents.component';
import { ModalUploadImageComponent } from './components/modals/modal-upload-image/modal-upload-image.component';
import { HistoryRecurrenceComponent } from './components/pages/historical/history-recurrence/history-recurrence.component';
import { PayrollComponent } from './components/pages/human-resources/payroll/payroll.component';
import { ExtraPaymentComponent } from './components/pages/human-resources/extra-payment/extra-payment.component'
import { DatePipe } from '@angular/common';
import { HistoryOrdersComponent } from './components/pages/historical/history-orders/history-orders.component';
import { AffiliatesComponent } from './components/pages/configuration/affiliates-configuration/affiliates/affiliates.component';
import { ModalCreateAffiliateComponent } from './components/modals/modal-create-affiliate/modal-create-affiliate.component';
import { AffiliatesConfigurationComponent } from './components/pages/configuration/affiliates-configuration/affiliates-configuration.component';
import { AffiliatesAdminComponent } from './components/pages/configuration/affiliates-configuration/affiliates-admin/affiliates-admin.component';
import { ModalSchemaPointComponent } from './components/modals/modal-schema-point/modal-schema-point.component';
import { ModalAffiliateEventComponent } from './components/modals/modal-affiliate-event/modal-affiliate-event.component';
import { HistoryDocsComponent } from './components/pages/historical/history-docs/history-docs.component';
import { HistoryOperationsComponent } from './components/pages/historical/history-operations/history-operations.component';
import { HistoryAccountingEntriesComponent } from './components/pages/historical/history-accounting-entries/history-accounting-entries.component';
import { HistoryInvoiceBagComponent } from './components/pages/historical/history-invoice-bag/history-invoice-bag.component';
import { SimpleModalComponent } from './components/modals/simple-modal/simple-modal.component';
import { ModalCompanyComponent } from './components/modals/modal-company/modal-company.component';
import { LoadingButtonComponent } from './components/elements/loading-button/loading-button.component';
import { ModalCreateAccountingEntryComponent } from './components/modals/modal-create-accounting-entry/modal-create-accounting-entry.component';
import { InpartnerComponent } from './components/pages/configuration/inpartner/inpartner.component';
import { ModalAssociateCompanyComponent } from './components/modals/modal-associate-company/modal-associate-company.component';
import { GeneralConfigurationComponent } from './components/pages/configuration/general-configuration/general-configuration.component';
import { ModalPurchaseSerieComponent } from './components/modals/modal-purchase-serie/modal-purchase-serie.component';
import { HistoryCashClosureComponent } from './components/pages/historical/history-cash-closure/history-cash-closure.component';
import { InAdminComponent } from './components/pages/in-admin/in-admin.component';
import { UploadDteComponent } from './components/pages/in-admin/upload-dte/upload-dte.component';
import { BankingComponent } from './components/pages/in-admin/banking/banking.component';
import { HistoryDteComponent } from './components/pages/in-admin/upload-dte/history-dte/history-dte.component';
import { UploadNewDteComponent } from './components/pages/in-admin/upload-dte/upload-new-dte/upload-new-dte.component';
import { UserPermissionsComponent } from './components/pages/in-admin/user-permissions/user-permissions.component';
import { HeatMapSalesComponent } from './components/pages/reports/heat-map-sales/heat-map-sales.component';
import { ModalCreateUserComponent } from './components/modals/modal-create-user/modal-create-user.component';
import { CompanyRequestComponent } from './components/pages/companies/company-request/company-request.component';
import { ModalCompanyRequestComponent } from './components/modals/modal-company-request/modal-company-request.component';
import { NewCompanyApplicationComponent } from './components/pages/companies/company-application/new-company-application/new-company-application.component';
import { TimeLeftPipe } from './common/time-left.pipe';
import { CompanyApplicationComponent } from './components/pages/companies/company-application/company-application.component';
import { ListApplicationsComponent } from './components/pages/companies/company-application/list-applications/list-applications.component';
import { SimplePaginationComponent } from './components/elements/simple-pagination/simple-pagination.component';
import { PasswordSatComponent } from './components/pages/in-admin/password-sat/password-sat.component';
import { ModalPasswordSatComponent } from './components/modals/modal-password-sat/modal-password-sat.component';
import { MapComponent } from './components/elements/map/map.component';
import { TaxFormListComponent } from './components/pages/in-admin/tax-form-list/tax-form-list.component';
import { TopProviderListComponent } from './components/modals/top-provider-list/top-provider-list.component';
import { TaxFormOneComponent } from './components/pages/in-admin/tax-form-list/tax-form-one/tax-form-one.component';
import { TaxFormTwoComponent } from './components/pages/in-admin/tax-form-list/tax-form-two/tax-form-two.component';
import { TaxFormThreeComponent } from './components/pages/in-admin/tax-form-list/tax-form-three/tax-form-three.component';
import { TaxFormFourComponent } from './components/pages/in-admin/tax-form-list/tax-form-four/tax-form-four.component';
import { TaxFormFiveComponent } from './components/pages/in-admin/tax-form-list/tax-form-five/tax-form-five.component';
import { PartnersAssociatedComponent } from './components/pages/configuration/inpartner/partners-associated/partners-associated.component';
import { CountInventoryComponent } from './components/pages/inventory/count-inventory/count-inventory.component';
import { LoadingAnimationComponent } from './components/elements/loading-animation/loading-animation.component';
import { HistoryInventoryComponent } from './components/pages/historical/history-inventory/history-inventory.component';
import { MakeInventoryComponent } from './components/pages/inventory/make-inventory/make-inventory.component';
import { DateDteComponent } from './components/pages/in-admin/date-dte/date-dte.component';
import { ModalPriorityInventoryComponent } from './components/modals/modal-priority-inventory/modal-priority-inventory.component';
import { NotPartnerDirective } from './security/not-partner.directive';
import { InformationInadminComponent } from './components/pages/in-admin/information-inadmin/information-inadmin.component';
import { AdministrativeInformationComponent } from './components/pages/in-admin/information-inadmin/administrative-information/administrative-information.component';
import { BalanceInformationComponent } from './components/pages/in-admin/information-inadmin/balance-information/balance-information.component';
import { ResultsInformationComponent } from './components/pages/in-admin/information-inadmin/results-information/results-information.component';
import { AccountingTaxFormsComponent } from './components/pages/configuration/accounting-tax-forms/accounting-tax-forms.component';
import { ModalTaxReturnComponent } from './components/modals/modal-tax-return/modal-tax-return.component';
import { BudgetChartsComponent } from './components/pages/report-charts/budget-charts/budget-charts.component';
import { BudgetSellsReportComponent } from './components/pages/report-charts/budget-charts/budget-sells-report/budget-sells-report.component';
import { BudgetProviderReportComponent } from './components/pages/report-charts/budget-charts/budget-provider-report/budget-provider-report.component';
import { SaleDetailChartComponent } from './components/charts/sale-detail-chart/sale-detail-chart.component';
import { SaleEstablishmentComponent } from './components/charts/sale-establishment/sale-establishment.component';
import { SaleInvoiceDetailChartComponent } from './components/charts/sale-invoice-detail-chart/sale-invoice-detail-chart.component';
import { ExpensesTypeEstablishmentReportComponent } from './components/charts/expenses-type-establishment-report/expenses-type-establishment-report.component';
import { ExpensesGeneralEstablishmentReportComponent } from './components/charts/expenses-general-establishment-report/expenses-general-establishment-report.component';
import { BillpayReceivableProviderComponent } from './components/charts/billpay-receivable-provider/billpay-receivable-provider.component';
import { ProviderInventoryEstablishmentReportComponent } from './components/charts/provider-inventory-establishment-report/provider-inventory-establishment-report.component';
import { InventoryChronologyReportComponent } from './components/charts/inventory-chronology-report/inventory-chronology-report.component';
import { ProviderChronologyReportComponent } from './components/charts/provider-chronology-report/provider-chronology-report.component';
import { BillReceivableChronologyComponent } from './components/charts/bill-receivable-chronology/bill-receivable-chronology.component';
import { BudgetGoalsReportComponent } from './components/pages/report-charts/budget-charts/budget-goals-report/budget-goals-report.component';
import { BillpayChronologyComponent } from './components/charts/billpay-chronology/billpay-chronology.component';
import { ModalWarehouseDaysXmlComponent } from './components/modals/modal-warehouse-days-xml/modal-warehouse-days-xml.component';
import { ModalUserAdministrativeComponent } from './components/modals/modal-user-administrative/modal-user-administrative.component';
import { NomenclatureComponent } from './components/pages/inventory/sales/nomenclature/nomenclature.component';
import { ExpenseCategoriesComponent } from './components/pages/configuration/expense-categories/expense-categories.component';
import { ModalExpenseCategoryComponent } from './components/modals/modal-expense-category/modal-expense-category.component';
import { DynamicTableComponent } from './components/pages/table/dynamic-table/dynamic-table.component';
import { LoadCsvFilesComponent } from './components/pages/configuration/load-csv-files/load-csv-files.component';
import { ModalErrorListComponent } from './components/modals/modal-error-list/modal-error-list.component';
import { HistoryTransferProductsComponent } from './components/pages/historical/history-transfer-products/history-transfer-products.component';
import { ReportOperationsComponent } from './components/pages/reports/report-operations/report-operations.component';
import { AssociatedProductsReportComponent } from './components/pages/reports/associated-products-report/associated-products-report.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TokenAlphaComponent } from './components/pages/inventory/sales/token-alpha/token-alpha.component';
import { DeleteClientInvoiceComponent } from './components/pages/in-admin/delete-duplicates/delete-client-invoice/delete-client-invoice.component';
import { DeleteDuplicatesComponent } from './components/pages/in-admin/delete-duplicates/delete-duplicates.component';
import { DeleteProviderInvoiceComponent } from './components/pages/in-admin/delete-duplicates/delete-provider-invoice/delete-provider-invoice.component';
import { AutomaticWithholdingsComponent } from './components/pages/in-admin/automatic-withholdings/automatic-withholdings.component';
import { AnalyticsExpenseComponent } from './components/pages/dashboard/analytics-expense/analytics-expense.component';
import { BankingSerpComponent } from './components/pages/inventory/banking-serp/banking-serp.component';
import { BillpUppayComponent } from './components/pages/dashboard/billp-uppay/billp-uppay.component';
import { BillrDownpayComponent } from './components/pages/dashboard/billr-downpay/billr-downpay.component';
import { ExpenseSubmitComponent } from './components/pages/dashboard/expense-submit/expense-submit.component';
import { PpeSubmitComponent } from './components/pages/dashboard/ppe-submit/ppe-submit.component';
import { HistoryPpeComponent } from './components/pages/historical/history-ppe/history-ppe.component';
import { HistoryRrhhComponent } from './components/pages/historical/history-rrhh/history-rrhh.component';
import { RrhhPayrollComponent } from './components/pages/human-resources/rrhh-payroll/rrhh-payroll.component';
import { ReportsDynamicComponent } from './components/pages/reports-dynamic/reports-dynamic.component';
import { ProviderSalesMonthComponent } from './components/pages/reports-dynamic/provider-sales-month/provider-sales-month.component';
import { InputAutocompleteSelectionComponent } from './components/elements/input-autocomplete-selection/input-autocomplete-selection.component';
import { ClientSalesMonthComponent } from './components/pages/reports-dynamic/client-sales-month/client-sales-month.component';
import { ClientSalesComponent } from './components/pages/reports-dynamic/client-sales/client-sales.component';
import { ProviderSalesComponent } from './components/pages/reports-dynamic/provider-sales/provider-sales.component';
import { InventoryProviderComponent } from './components/pages/reports-dynamic/inventory-provider/inventory-provider.component';
import { InventoryCostComponent } from './components/pages/reports-dynamic/inventory-cost/inventory-cost.component';
import { ChronologyComponent } from './components/pages/reports-dynamic/chronology/chronology.component';
import { HeatMapOutcomeComponent } from './components/pages/reports/heat-map-outcome/heat-map-outcome.component';
import { ModalVendorBankComponent } from './components/modals/modal-vendor-bank/modal-vendor-bank.component';
import { BiTransfersComponent } from './components/pages/dashboard/bi-transfers/bi-transfers.component';
import { ReconciliationReportComponent } from './components/pages/in-admin/upload-dte/reconciliation-report/reconciliation-report.component';
import { AdministrativeCompaniesComponent } from './components/pages/in-admin/administrative/administrative-companies/administrative-companies.component';
import { AdministrativeWarehouseComponent } from './components/pages/configuration/administrative-warehouse/administrative-warehouse.component';
import { ParticularityInvoiceRoutingComponent } from './components/pages/configuration/particularity-invoice-routing/particularity-invoice-routing.component';
import { PurchasesOrderComponent } from './components/pages/inventory/orders/purchases-order/purchases-order.component';
import { RecipesComponent } from './components/pages/configuration/inventory/recipes/recipes.component';
import { EditRecipeComponent } from './components/pages/configuration/inventory/recipes/edit-recipe/edit-recipe.component';
import { ModalCreateOrderV2Component } from './components/modals/modal-create-order-v2/modal-create-order-v2.component';
import { PurchasesOrderActiveTableComponent } from './components/pages/inventory/orders/purchases-order/purchases-order-active-table/purchases-order-active-table.component';
import { ModalPurchaseOrderDetailComponent } from './components/modals/modal-purchase-order-detail/modal-purchase-order-detail.component';
import { OrderAssociationComponent } from './components/pages/inventory/orders/order-association/order-association.component';
import { OrderReceivedComponent } from './components/pages/inventory/orders/order-received/order-received.component';
import { ModalDialogComponent } from './components/modals/modal-dialog/modal-dialog.component';
import { PurchasesOrderDesactiveTableComponent } from './components/pages/inventory/orders/purchases-order/purchases-order-desactive-table/purchases-order-desactive-table.component';
import { HistoryPurchasesPendingReceiptComponent } from './components/pages/historical/history-purchases-pending-receipt/history-purchases-pending-receipt.component';
import { HistoryPurchasesPendingComponent } from './components/pages/historical/history-purchases-pending/history-purchases-pending.component';
import { PurchasePendingReceiptDetailsComponent } from './components/pages/historical/history-purchases-pending/purchase-pending-receipt-details/purchase-pending-receipt-details.component';
import { DetailDocsComponent } from './components/pages/historical/history-docs/detail-docs/detail-docs.component';
import { PriceListGroupComponent } from './components/pages/inventory/sales/price-list/price-list-group/price-list-group.component';
import { PriceListProductsGroupComponent } from './components/pages/inventory/sales/price-list/price-list-products-group/price-list-products-group.component';
import { OrderPurchaseCalendarReportComponent } from './components/pages/reports/order-purchase-calendar-report/order-purchase-calendar-report.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TotalPurchaseOrderCalendarDaysComponent } from './components/pages/reports/order-purchase-calendar-report/total-purchase-order-calendar-days/total-purchase-order-calendar-days.component';
import { AssociationPurchaseOrderComponent } from './components/pages/inventory/orders/association-purchase-order/association-purchase-order.component';
import { PurchaseAssociationComponent } from './components/pages/inventory/orders/purchase-association/purchase-association.component';
import { EntryNoteComponent } from './components/pages/inventory/notes/entry-note/entry-note.component';
import { AssociationEntryNoteComponent } from './components/pages/inventory/notes/association-entry-note/association-entry-note.component';
import { CreateEntryNoteComponent } from './components/pages/inventory/notes/entry-note/create-entry-note/create-entry-note.component';
import { EntryNoteDetailsComponent } from './components/pages/inventory/notes/entry-note/entry-note-details/entry-note-details.component';
import { EntrynoteOrderAssociationComponent } from './components/pages/inventory/notes/entrynote-order-association/entrynote-order-association.component';
import { EntrynotePurchaseAssociationComponent } from './components/pages/inventory/notes/entrynote-purchase-association/entrynote-purchase-association.component';
import { LogoColorComponent } from './components/elements/logo-color/logo-color.component';
import { BiTransferHistoryComponent } from './components/pages/dashboard/bi-transfers/bi-transfer-history/bi-transfer-history.component';
import { BiTransferTransactionComponent } from './components/pages/dashboard/bi-transfers/bi-transfer-transaction/bi-transfer-transaction.component';
import { CoasParameterComponent } from './components/pages/configuration/coas/coas-parameter/coas-parameter.component';
import { ParametersProductsComponent } from './components/pages/configuration/coas/parameters-products/parameters-products.component';
import { CoasComponent } from './components/pages/configuration/coas/coas.component';
import { CertificatesOfAnalysisComponent } from './components/pages/inventory/coas/certificates-of-analysis/certificates-of-analysis.component';
import { CreateCoaComponent } from './components/pages/inventory/coas/certificates-of-analysis/create-coa/create-coa.component';
import { CoaDetailsComponent } from './components/pages/inventory/coas/certificates-of-analysis/coa-details/coa-details.component';
import { ProductsCpComponent } from './components/pages/configuration/coas/products-cp/products-cp.component';
import { AssociationPriceListWarehouseComponent } from './components/pages/inventory/sales/price-list/association-price-list-warehouse/association-price-list-warehouse.component';
import { PriceListCrudComponent } from './components/pages/inventory/sales/price-list/price-list-crud/price-list-crud.component';
import { GeographicMapComponent } from './components/pages/geographic-map/geographic-map.component';
import { RecipeDiagramComponent } from './components/pages/inventory/recipe-diagram/recipe-diagram.component';
import { Ngx3JsModule } from 'ngx3js';
import { ViewWarehouseComponent } from './components/pages/inventory/view-warehouse/view-warehouse.component';
import { ViewWarehouseContainerComponent } from './components/pages/inventory/view-warehouse/view-warehouse-container/view-warehouse-container.component';
import { ViewWarehouseCylinderComponent } from './components/pages/inventory/view-warehouse/view-warehouse-cylinder/view-warehouse-cylinder.component';
import { ViewWarehouseCylinderMultiComponent } from './components/pages/inventory/view-warehouse/view-warehouse-cylinder-multi/view-warehouse-cylinder-multi.component';
import { ViewWarehouseContainerMultiComponent } from './components/pages/inventory/view-warehouse/view-warehouse-container-multi/view-warehouse-container-multi.component';
import { ScalesNoteComponent } from './components/pages/inventory/notes/scales-note/scales-note.component';
import { CreateScaleNoteComponent } from './components/pages/inventory/notes/scales-note/create-scale-note/create-scale-note.component';
import { ScaleNoteDetailsComponent } from './components/pages/inventory/notes/scales-note/scale-note-details/scale-note-details.component';
import { AssociationEntryNoteCoaComponent } from './components/pages/inventory/notes/association-entry-note-coa/association-entry-note-coa.component';
import { OrderRecievedUnifiedComponent } from './components/pages/inventory/orders/order-recieved-unified/order-recieved-unified.component';
import { ProductionProcessComponent } from './components/pages/configuration/production-process/production-process.component';
import { CreateProductionProcessComponent } from './components/pages/inventory/production-process/create-production-process/create-production-process.component';
import { EditProductionProcessComponent } from './components/pages/configuration/production-process/edit-production-process/edit-production-process.component';
import { ExecutionProductionProcessComponent } from './components/pages/inventory/production-process/execution-production-process/execution-production-process.component';
import { ProcessWarehouseComponent } from './components/pages/inventory/production-process/execution-production-process/process-warehouse/process-warehouse.component';
import { ModalGeographicDetailsComponent } from './components/modals/modal-geographic-details/modal-geographic-details.component';
import { LogoNameColorComponent } from './components/elements/logo-name-color/logo-name-color.component';
import { DestinationComponent } from './components/pages/destination/destination.component';
import { DestinationListComponent } from './components/pages/destination/destination-list/destination-list.component';
import { AssociationDestinationWarehousesComponent } from './components/pages/destination/association-destination-warehouses/association-destination-warehouses.component';
import { DestinationListGroupComponent } from './components/pages/destination/destination-list-group/destination-list-group.component';
import { DestinationWarehousesListComponent } from './components/pages/destination/destination-warehouses-list/destination-warehouses-list.component';
import { ModalAssigningDetinationExpenseComponent } from './components/modals/modal-assigning-detination-expense/modal-assigning-detination-expense.component';
import { HistoryOrderReservationComponent } from './components/pages/historical/history-order-reservation/history-order-reservation.component';
import { DetailOrderReservationComponent } from './components/pages/historical/history-order-reservation/detail-order-reservation/detail-order-reservation.component';
import { DestinationsComponent } from './components/pages/configuration/destinations/destinations.component';
import { HistoryProductionsProcessComponent } from './components/pages/historical/history-productions-process/history-productions-process.component';
import { HistoryProductionComponent } from './components/pages/historical/history-productions-process/history-production/history-production.component';
import { MayeReportsComponent } from './components/pages/reports/maye-reports/maye-reports.component';
import { GroupedDetailOrderReservationComponent } from './components/pages/historical/history-order-reservation/grouped-detail-order-reservation/grouped-detail-order-reservation.component';
import { ProductionDetailsComponent } from './components/pages/historical/history-productions-process/history-production/production-details/production-details.component';
import { ProductionDetailsResultComponent } from './components/pages/historical/history-productions-process/history-production/production-details-result/production-details-result.component';
import { TransferBanksCashsComponent } from './components/pages/dashboard/transferCashBank/transfer-banks-cashs/transfer-banks-cashs.component';
import { TransferBankCashComponent } from './components/pages/dashboard/transferCashBank/transfer-bank-cash/transfer-bank-cash.component';
import { TransferBankBankComponent } from './components/pages/dashboard/transferCashBank/transfer-bank-bank/transfer-bank-bank.component';
import { TransferCashCashComponent } from './components/pages/dashboard/transferCashBank/transfer-cash-cash/transfer-cash-cash.component';
import { ExtractionsReportsComponent } from './components/pages/reports/extractions-reports/extractions-reports.component';
import { AssociationPriceListDestinationComponent } from './components/pages/inventory/sales/price-list/association-price-list-destination/association-price-list-destination.component';
import { AssociationsExitNoteComponent } from './components/pages/inventory/notes/associations-exit-note/associations-exit-note.component';
import { AssociationExitNoteSaleComponent } from './components/pages/inventory/notes/associations-exit-note/association-exit-note-sale/association-exit-note-sale.component';
import { AssociationExitNoteCoaComponent } from './components/pages/inventory/notes/associations-exit-note/association-exit-note-coa/association-exit-note-coa.component';
import { ExitNoteComponent } from './components/pages/inventory/notes/exit-note/exit-note.component';
import { CreateExitNoteComponent } from './components/pages/inventory/notes/exit-note/create-exit-note/create-exit-note.component';
import { ExitNoteDetailsComponent } from './components/pages/inventory/notes/exit-note/exit-note-details/exit-note-details.component';
import { EmployeeListComponent } from './components/pages/human-resources/employee-list/employee-list.component';
import { EmployeeSuspensionsComponent } from './components/pages/human-resources/employee-suspensions/employee-suspensions.component';
import { ModalEditWarehousePurchaseOrderDetailComponent } from './components/pages/inventory/orders/modal-edit-warehouse-purchase-order-detail/modal-edit-warehouse-purchase-order-detail.component';
import { ProductTempProcessComponent } from './components/pages/inventory/production-process/execution-production-process/product-temp-process/product-temp-process.component';
import { BillrDownnoteComponent } from './components/pages/dashboard/billr-downnote/billr-downnote.component';
import { AppliesPpComponent } from './components/pages/historical/history-docs/applies-pp/applies-pp.component';
import { ProductRoutingComponent } from './components/pages/configuration/product-routing/product-routing.component';
import { GeographicMapRoutesComponent } from './components/pages/geographic-map/geographic-map-routes/geographic-map-routes.component';
import { ClientsInactiveDaysComponent } from './components/pages/geographic-map/clients-inactive-days/clients-inactive-days.component';
import { CostListCrudComponent } from './components/pages/inventory/sales/price-list/cost-list-crud/cost-list-crud.component';
import { AdministrativeAutoSalePurchaseComponent } from './components/pages/configuration/administrative-auto-sale-purchase/administrative-auto-sale-purchase.component';
import { PlaceListComponent } from './components/pages/place-list/place-list.component';
import { AssociationPlaceDestinationComponent } from './components/pages/place-list/association-place-destination/association-place-destination.component';
import { PlaceDestinationMayePreviewComponent } from './components/pages/reports/maye-reports/place-destination-maye-preview/place-destination-maye-preview.component';
import { ResultPlaceMayePreviewComponent } from './components/pages/reports/maye-reports/result-place-maye-preview/result-place-maye-preview.component';
import { ProfitMarginReportPreviewComponent } from './components/pages/reports/inventory-report/profit-margin-report-preview/profit-margin-report-preview.component';
import { OrderOfOrdersSalePreviewComponent } from './components/pages/reports/maye-reports/order-of-orders-sale-preview/order-of-orders-sale-preview.component';
import { SalesBookMayePreviewComponent } from './components/pages/reports/maye-reports/sales-book-maye-preview/sales-book-maye-preview.component';
import { ProfitMarginMayePreviewComponent } from './components/pages/reports/maye-reports/profit-margin-maye-preview/profit-margin-maye-preview.component';
import { ExistencesByPlaceMayePreviewComponent } from './components/pages/reports/maye-reports/existences-by-place-maye-preview/existences-by-place-maye-preview.component';
import { PlaceInventoryByPlacePreviewComponent } from './components/pages/reports/maye-reports/place-inventory-by-place-preview/place-inventory-by-place-preview.component';
import { ClientDestinationMayePreviewComponent } from './components/pages/reports/maye-reports/client-destination-maye-preview/client-destination-maye-preview.component';
import { DepositConfigComponent } from './components/pages/dashboard/deposit-config/deposit-config.component';
import { HistoryDestinationCashClosureComponent } from './components/pages/historical/history-destination-cash-closure/history-destination-cash-closure.component';
import { GeneralTablePreviewComponent } from './components/pages/reports/maye-reports/general-table-preview/general-table-preview.component';
import { BamTransfersComponent } from './components/pages/dashboard/bam-transfers/bam-transfers.component';
import { BamTransferTransactionComponent } from './components/pages/dashboard/bam-transfers/bam-transfer-transaction/bam-transfer-transaction.component';
import { BamTransferHistoryComponent } from './components/pages/dashboard/bam-transfers/bam-transfer-history/bam-transfer-history.component';
import { BamPayrollComponent } from './components/pages/dashboard/bam-transfers/bam-payroll/bam-payroll.component';
import { BamTaxesComponent } from './components/pages/dashboard/bam-transfers/bam-taxes/bam-taxes.component';
import { BamCreditCardComponent } from './components/pages/dashboard/bam-transfers/bam-credit-card/bam-credit-card.component';
import { BamLoanComponent } from './components/pages/dashboard/bam-transfers/bam-loan/bam-loan.component';
import { BamInternationalTransferComponent } from './components/pages/dashboard/bam-transfers/bam-international-transfer/bam-international-transfer.component';
import { ViewBatchComponent } from './components/pages/dashboard/bam-transfers/bam-transfer-history/view-batch/view-batch.component';
import { BamQueriesComponent } from './components/pages/dashboard/bam-transfers/bam-queries/bam-queries.component';
import { BamQueryMovementsComponent } from './components/pages/dashboard/bam-transfers/bam-queries/bam-query-movements/bam-query-movements.component';
import { BamQueryAccountStatusComponent } from './components/pages/dashboard/bam-transfers/bam-queries/bam-query-account-status/bam-query-account-status.component';
import { BamQueryVoucherComponent } from './components/pages/dashboard/bam-transfers/bam-queries/bam-query-voucher/bam-query-voucher.component';
import { BamQueryMt940Component } from './components/pages/dashboard/bam-transfers/bam-queries/bam-query-mt940/bam-query-mt940.component';
import { BamAddFavoriteComponent } from './components/pages/dashboard/bam-transfers/bam-add-favorite/bam-add-favorite.component';
import { BamFavoritesHistoryComponent } from './components/pages/dashboard/bam-transfers/bam-favorites-history/bam-favorites-history.component';
import { ParametersProductsListComponent } from './components/pages/configuration/coas/parameters-products/parameters-products-list/parameters-products-list.component';
import { ParametersProductsTemplatesComponent } from './components/pages/configuration/coas/parameters-products/parameters-products-templates/parameters-products-templates.component';
import { AnalyticsSalesComponent } from './components/pages/dashboard/analytics-sales/analytics-sales.component';
import { AnalyticsPurchasesComponent } from './components/pages/dashboard/analytics-purchases/analytics-purchases.component';
import { AnalyticsCxcComponent } from './components/pages/dashboard/analytics-cxc/analytics-cxc.component';
import { AnalyticsCxpComponent } from './components/pages/dashboard/analytics-cxp/analytics-cxp.component';
import { SupersetEmbeddedComponent } from './components/pages/dashboard/superset-embedded/superset-embedded.component';
import { AffiliatePointsHistoricalComponent } from './components/pages/configuration/affiliates-configuration/affiliate-points-historical/affiliate-points-historical.component';
import { EmployeeActiveListComponent } from './components/pages/human-resources/employee-list/employee-active-list/employee-active-list.component';
import { EmployeeInactiveListComponent } from './components/pages/human-resources/employee-list/employee-inactive-list/employee-inactive-list.component';
import { HistoryWithholdingsComponent } from './components/pages/historical/history-withholdings/history-withholdings.component';
import { FiscalDocumentsCountComponent } from './components/pages/in-admin/fiscal-documents-count/fiscal-documents-count.component';
import { ViewFavoriteBatchComponent } from './components/pages/dashboard/bam-transfers/bam-favorites-history/view-favorite-batch/view-favorite-batch.component';
import { HumanResourcesReportComponent } from './components/pages/reports/human-resources-report/human-resources-report.component';
import { ProductsFavoritesComponent } from './components/pages/configuration/inventory/products-favorites/products-favorites.component';
import { ModalCreateProductFavoriteComponent } from './components/modals/modal-create-product-favorite/modal-create-product-favorite.component';
import { PartnersNotAssociatedComponent } from './components/pages/configuration/inpartner/partners-not-associated/partners-not-associated.component';
import { ModalVendorBillingNitComponent } from './components/modals/modal-vendor-billing-nit/modal-vendor-billing-nit.component';
import { ModalClientCfComponent } from './components/modals/modal-client-cf/modal-client-cf.component';
import { DepositRequestComponent } from './components/pages/dashboard/deposit-request/deposit-request.component';
import { HistoryAnnulSalesComponent } from './components/pages/historical/history-annul-sales/history-annul-sales.component';
import { ProductsPosibleTransformationComponent } from './components/pages/inventory/sales/products-posible-transformation/products-posible-transformation.component';
import { HistoryAdvancePaymentComponent } from './components/pages/historical/history-advance-payment/history-advance-payment.component';
import { ProductConversionComponent } from './components/pages/configuration/product-conversion/product-conversion.component';
import { LoyaltyRegisterComponent } from './components/loyalty-register/loyalty-register.component';
import { ProductRoutingPurchasesComponent } from './components/pages/configuration/product-routing-purchases/product-routing-purchases.component';
import { AssociationPriceListPlaceComponent } from './components/pages/inventory/sales/price-list/association-price-list-place/association-price-list-place.component';
import { PriceListByLocationComponent } from './components/pages/inventory/sales/price-list-by-location/price-list-by-location.component';
import { PassBusinessComponent } from './components/pages/in-admin/pass-business/pass-business.component';
import { ModalPassBusinessComponent } from './components/modals/modal-pass-business/modal-pass-business.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    DashboardComponent,
    AnalyticsComponent,
    EcommerceComponent,
    AppChatComponent,
    AppTodoComponent,
    AppCalendarComponent,
    PricingComponent,
    TimelineComponent,
    GalleryComponent,
    FaqComponent,
    InvoiceComponent,
    BlankPageComponent,
    ProfileComponent,
    GridComponent,
    ColorsComponent,
    BoxiconsComponent,
    FeathericonsComponent,
    IconsComponent,
    CardComponent,
    BasicCardComponent,
    ColorsCardComponent,
    StatisticsCardComponent,
    FormComponent,
    FormLayoutComponent,
    FormInputGroupComponent,
    TableComponent,
    TableLightComponent,
    TableDarkComponent,
    InboxComponent,
    ReadComponent,
    ComposeComponent,
    UiComponentsComponent,
    AlertsComponent,
    AppEmailComponent,
    BadgesComponent,
    BordersComponent,
    BreadcrumbComponent,
    ButtonsComponent,
    ButtonsGroupComponent,
    SliderComponent,
    CollapseComponent,
    DisplayComponent,
    DropdownComponent,
    EmbedComponent,
    FiguresComponent,
    ImagesComponent,
    JumbotronComponent,
    ListGroupComponent,
    MediaObjectComponent,
    ModalComponent,
    NavsComponent,
    NavbarComponent,
    SpinnerComponent,
    TextComponent,
    VerticalAlignmentComponent,
    TypographyComponent,
    TooltipsComponent,
    PopoversComponent,
    ProgressComponent,
    AuthenticationComponent,
    LoginComponent,
    LoginWithImageComponent,
    RegisterComponent,
    RegisterWithImageComponent,
    ForgotPasswordComponent,
    ForgotPasswordWithImageComponent,
    ResetPasswordComponent,
    ResetPasswordWithImageComponent,
    SessionLockScreenComponent,
    SessionLockScreenWithImageComponent,
    NotAuthorizedComponent,
    NotAuthorizedWithImageComponent,
    MaintenanceComponent,
    MaintenanceWithImageComponent,
    ComingSoonComponent,
    ComingSoonWithImageComponent,
    MiscellaneousComponent,
    ErrorComponent,
    Errorv1Component,
    Errorv2Component,
    Errorv3Component,
    Errorv4Component,
    MapsComponent,
    WebAnalyticsComponent,
    EmailSendComponent,
    ActivityTimelineComponent,
    TrafficSourceComponent,
    RevenueSummaryComponent,
    ClientRecollectionComponent,
    RevenueGrowthComponent,
    ApexChartsComponent,
    BasicLineChartComponent,
    LineWithDataLabelsComponent,
    AnnotationsLineComponent,
    GradientLineComponent,
    DashedLineComponent,
    ZoomableLineTimeseriesComponent,
    BasicAreaChartComponent,
    SplineAreaComponent,
    NegativeAreaComponent,
    StackedAreaComponent,
    AreaDatetimeXAxisComponent,
    BasicColumnChartComponent,
    ColumnWithDataLabelsComponent,
    StackedColumnsComponent,
    StackedColumnsHundredPercentComponent,
    ColumnWithNegativeValuesComponent,
    DynamicLoadedColumnComponent,
    BasicBarChartComponent,
    GroupedBarComponent,
    StackedBarComponent,
    StackedBarHundredPercentComponent,
    BarWithNegativeValuesComponent,
    CustomDatalabelsBarComponent,
    MixedLineColumnComponent,
    MixedMultipleYAxisComponent,
    MixedLineAndAreaComponent,
    MixedLineColumnAreaComponent,
    SimplePieChartComponent,
    SimpleDonutChartComponent,
    MonochromePieComponent,
    GradientDonutComponent,
    DonutWithPatternComponent,
    PieWithImageComponent,
    BasicRadialbarChartComponent,
    MultipleRadialbarComponent,
    RadialbarCustomAngleCircleComponent,
    RadialbarGradientCircleComponent,
    RadialbarStrokedCircularGaugeComponent,
    RadialbarSemiCircularGaugeComponent,
    RadialbarsWithImageComponent,
    BasicRadarChartComponent,
    RadarMultipleSeriesComponent,
    RadarWithPolygonFillComponent,
    ChartjsComponent,
    BasicBarChartv2Component,
    BasicLineChartv2Component,
    BasicPieChartComponent,
    BasicRadarChartv2Component,
    BasicHorizontalBarComponent,
    BarWithLineComponent,
    ResendConfirmationComponent,
    InvoiceSaleComponent,
    RecurrenceComponent,
    SelectCompanyComponent,
    IdleModalComponent,
    InputAutocompleteComponent,
    SuccessModalComponent,
    CashClosureComponent,
    SalesComponent,
    EditInvoiceComponent,
    AccountsReceivableComponent,
    ConfigurationComponent,
    RolesAndPermissionsComponent,
    PriceListComponent,
    PriceListModalComponent,
    UserRoleComponent,
    CheckPermissionDirective,
    HumanResourcesComponent,
    OrganizationComponent,
    D3OrgChartComponent,
    InventoryComponent,
    CategoriesComponent,
    ReportsComponent,
    InventoryReportComponent,
    BankReportComponent,
    PaginationComponent,
    AccountReceivableReportComponent,
    AccountPayableReportComponent,
    SpendingReportComponent,
    CashBankComponent,
    AccountingReportComponent,
    WarehousesComponent,
    BankConfigurationComponent,
    AccountsConfigurationComponent,
    ModalCreateWarehouseComponent,
    ModalEditWarehouseComponent,
    CashiersComponent,
    ModalCashierComponent,
    VendorsComponent,
    BudgetComponent,
    ModalVendorComponent,
    HistorySalesComponent,
    ModalInvoiceSaleComponent,
    HistoryCotiComponent,
    AccountingChartResultComponent,
    AccountingChartBalanceComponent,
    AccountingChartExpensesComponent,
    AccountingChartProfitsVsCostsComponent,
    AnalyticsCustomComponent,
    HistoricalComponent,
    HistoryPurchasesComponent,
    PurchasesComponent,
    InvoicePurchaseComponent,
    ProductsComponent,
    ModalCreateProductComponent,
    OrdersComponent,
    OrderListComponent,
    ModalCreateOrderComponent,
    ModalCreatePurchaseOrderComponent,
    ProfitMarginComponent,
    ModalPolishOffOrderComponent,
    JobsComponent,
    ModalLocationComponent,
    TransferProductsComponent,
    ModalAdminAreaComponent,
    ModalQuestionComponent,
    ModalAdminDepartmentComponent,
    ModalAdminPositionComponent,
    HiringComponent,
    ModalHiringComponent,
    ModalSalaryProfileComponent,
    ModalHiringDocumentsComponent,
    ModalUploadImageComponent,
    HistoryRecurrenceComponent,
    PayrollComponent,
    ExtraPaymentComponent,
    HistoryOrdersComponent,
    AffiliatesComponent,
    ModalCreateAffiliateComponent,
    AffiliatesConfigurationComponent,
    AffiliatesAdminComponent,
    ModalSchemaPointComponent,
    ModalAffiliateEventComponent,
    HistoryDocsComponent,
    HistoryOperationsComponent,
    HistoryAccountingEntriesComponent,
    HistoryInvoiceBagComponent,
    SimpleModalComponent,
    ModalCompanyComponent,
    LoadingButtonComponent,
    ModalCreateAccountingEntryComponent,
    InpartnerComponent,
    ModalAssociateCompanyComponent,
    GeneralConfigurationComponent,
    ModalPurchaseSerieComponent,
    HistoryCashClosureComponent,
    InAdminComponent,
    UploadDteComponent,
    BankingComponent,
    HistoryDteComponent,
    UploadNewDteComponent,
    UserPermissionsComponent,
    HeatMapSalesComponent,
    ModalCreateUserComponent,
    CompanyRequestComponent,
    ModalCompanyRequestComponent,
    NewCompanyApplicationComponent,
    TimeLeftPipe,
    CompanyApplicationComponent,
    ListApplicationsComponent,
    SimplePaginationComponent,
    PasswordSatComponent,
    ModalPasswordSatComponent,
    MapComponent,
    TaxFormListComponent,
    TopProviderListComponent,
    TaxFormOneComponent,
    TaxFormTwoComponent,
    TaxFormThreeComponent,
    TaxFormFourComponent,
    TaxFormFiveComponent,
    PartnersAssociatedComponent,
    CountInventoryComponent,
    LoadingAnimationComponent,
    HistoryInventoryComponent,
    MakeInventoryComponent,
    DateDteComponent,
    ModalPriorityInventoryComponent,
    NotPartnerDirective,
    InformationInadminComponent,
    AdministrativeInformationComponent,
    BalanceInformationComponent,
    ResultsInformationComponent,
    AccountingTaxFormsComponent,
    ModalTaxReturnComponent,
    BudgetChartsComponent,
    BudgetSellsReportComponent,
    BudgetProviderReportComponent,
    SaleDetailChartComponent,
    SaleEstablishmentComponent,
    SaleInvoiceDetailChartComponent,
    ExpensesTypeEstablishmentReportComponent,
    ExpensesGeneralEstablishmentReportComponent,
    BillpayReceivableProviderComponent,
    ProviderInventoryEstablishmentReportComponent,
    InventoryChronologyReportComponent,
    ProviderChronologyReportComponent,
    BillReceivableChronologyComponent,
    BudgetGoalsReportComponent,
    BillpayChronologyComponent,
    ModalWarehouseDaysXmlComponent,
    ModalUserAdministrativeComponent,
    NomenclatureComponent,
    ExpenseCategoriesComponent,
    ModalExpenseCategoryComponent,
    DynamicTableComponent,
    LoadCsvFilesComponent,
    ModalErrorListComponent,
    HistoryTransferProductsComponent,
    ReportOperationsComponent,
    AssociatedProductsReportComponent,
    TokenAlphaComponent,
    DeleteClientInvoiceComponent,
    DeleteDuplicatesComponent,
    DeleteProviderInvoiceComponent,
    AutomaticWithholdingsComponent,
    AnalyticsExpenseComponent,
    BankingSerpComponent,
    BillpUppayComponent,
    BillrDownpayComponent,
    ExpenseSubmitComponent,
    PpeSubmitComponent,
    HistoryPpeComponent,
    HistoryRrhhComponent,
    RrhhPayrollComponent,
    ReportsDynamicComponent,
    ProviderSalesMonthComponent,
    InputAutocompleteSelectionComponent,
    ClientSalesMonthComponent,
    ClientSalesComponent,
    ProviderSalesComponent,
    InventoryProviderComponent,
    InventoryCostComponent,
    ChronologyComponent,
    HeatMapOutcomeComponent,
    ModalVendorBankComponent,
    BiTransfersComponent,
    ReconciliationReportComponent,
    AdministrativeCompaniesComponent,
    AdministrativeWarehouseComponent,
    ParticularityInvoiceRoutingComponent,
    PurchasesOrderComponent,
    RecipesComponent,
    EditRecipeComponent,
    ModalCreateOrderV2Component,
    PurchasesOrderActiveTableComponent,
    ModalPurchaseOrderDetailComponent,
    OrderAssociationComponent,
    OrderReceivedComponent,
    ModalDialogComponent,
    PurchasesOrderDesactiveTableComponent,
    HistoryPurchasesPendingReceiptComponent,
    HistoryPurchasesPendingComponent,
    PurchasePendingReceiptDetailsComponent,
    DetailDocsComponent,
    PriceListGroupComponent,
    PriceListProductsGroupComponent,
    OrderPurchaseCalendarReportComponent,
    TotalPurchaseOrderCalendarDaysComponent,
    AssociationPurchaseOrderComponent,
    PurchaseAssociationComponent,
    EntryNoteComponent,
    AssociationEntryNoteComponent,
    CreateEntryNoteComponent,
    EntryNoteDetailsComponent,
    EntrynoteOrderAssociationComponent,
    EntrynotePurchaseAssociationComponent,
    LogoColorComponent,
    BiTransferHistoryComponent,
    BiTransferTransactionComponent,
    CoasParameterComponent,
    ParametersProductsComponent,
    CoasComponent,
    CertificatesOfAnalysisComponent,
    CreateCoaComponent,
    CoaDetailsComponent,
    ProductsCpComponent,
    AssociationPriceListWarehouseComponent,
    PriceListCrudComponent,
    GeographicMapComponent,
    RecipeDiagramComponent,
    ViewWarehouseComponent,
    ViewWarehouseContainerComponent,
    ViewWarehouseCylinderComponent,
    ViewWarehouseCylinderMultiComponent,
    ViewWarehouseContainerMultiComponent,
    ScalesNoteComponent,
    CreateScaleNoteComponent,
    ScaleNoteDetailsComponent,
    AssociationEntryNoteCoaComponent,
    OrderRecievedUnifiedComponent,
    ProductionProcessComponent,
    CreateProductionProcessComponent,
    EditProductionProcessComponent,
    ExecutionProductionProcessComponent,
    ProcessWarehouseComponent,
    ModalGeographicDetailsComponent,
    LogoNameColorComponent,
    DestinationComponent,
    DestinationListComponent,
    AssociationDestinationWarehousesComponent,
    DestinationListGroupComponent,
    DestinationWarehousesListComponent,
    ModalAssigningDetinationExpenseComponent,
    HistoryOrderReservationComponent,
    DetailOrderReservationComponent,
    DestinationsComponent,
    HistoryProductionsProcessComponent,
    HistoryProductionComponent,
    MayeReportsComponent,
    GroupedDetailOrderReservationComponent,
    ProductionDetailsComponent,
    ProductionDetailsResultComponent,
    TransferBanksCashsComponent,
    TransferBankCashComponent,
    TransferBankBankComponent,
    TransferCashCashComponent,
    ExtractionsReportsComponent,
    AssociationPriceListDestinationComponent,
    AssociationsExitNoteComponent,
    AssociationExitNoteSaleComponent,
    AssociationExitNoteCoaComponent,
    ExitNoteComponent,
    CreateExitNoteComponent,
    ExitNoteDetailsComponent,
    EmployeeListComponent,
    EmployeeSuspensionsComponent,
    ModalEditWarehousePurchaseOrderDetailComponent,
    ProductTempProcessComponent,
    BillrDownnoteComponent,
    AppliesPpComponent,
    ProductRoutingComponent,
    GeographicMapRoutesComponent,
    ClientsInactiveDaysComponent,
    CostListCrudComponent,
    AdministrativeAutoSalePurchaseComponent,
    PlaceListComponent,
    AssociationPlaceDestinationComponent,
    PlaceDestinationMayePreviewComponent,
    ResultPlaceMayePreviewComponent,
    ProfitMarginReportPreviewComponent,
    OrderOfOrdersSalePreviewComponent,
    SalesBookMayePreviewComponent,
    ProfitMarginMayePreviewComponent,
    ExistencesByPlaceMayePreviewComponent,
    PlaceInventoryByPlacePreviewComponent,
    ClientDestinationMayePreviewComponent,
    DepositConfigComponent,
    HistoryDestinationCashClosureComponent,
    GeneralTablePreviewComponent,
    BamTransfersComponent,
    BamTransferTransactionComponent,
    BamTransferHistoryComponent,
    BamPayrollComponent,
    BamTaxesComponent,
    BamCreditCardComponent,
    BamLoanComponent,
    BamInternationalTransferComponent,
    ViewBatchComponent,
    BamQueriesComponent,
    BamQueryMovementsComponent,
    BamQueryAccountStatusComponent,
    BamQueryVoucherComponent,
    BamQueryMt940Component,
    BamAddFavoriteComponent,
    BamFavoritesHistoryComponent,
    ParametersProductsListComponent,
    ParametersProductsTemplatesComponent,
    AnalyticsPurchasesComponent,
    AnalyticsSalesComponent,
    AnalyticsCxcComponent,
    AnalyticsCxpComponent,
    SupersetEmbeddedComponent,
    AffiliatePointsHistoricalComponent,
    EmployeeActiveListComponent,
    EmployeeInactiveListComponent,
    HistoryWithholdingsComponent,
    FiscalDocumentsCountComponent,
    ViewFavoriteBatchComponent,
    HumanResourcesReportComponent,
    ProductsFavoritesComponent,
    ModalCreateProductFavoriteComponent,
    PartnersNotAssociatedComponent,
    ModalVendorBillingNitComponent,
    ModalClientCfComponent,
    DepositRequestComponent,
    HistoryAnnulSalesComponent,
    ProductsPosibleTransformationComponent,
    HistoryAdvancePaymentComponent,
    ProductConversionComponent,
    LoyaltyRegisterComponent,
    ProductRoutingPurchasesComponent,
    AssociationPriceListPlaceComponent,
    PriceListByLocationComponent,
    PassBusinessComponent,
    ModalPassBusinessComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgIdleKeepaliveModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ImageCropperModule,
    TooltipModule.forRoot(),
    ScrollingModule,
    FullCalendarModule,
    Ngx3JsModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticationInterceptor,
    multi: true,
  }, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
